import { render, staticRenderFns } from "./IlamBilgileriForm.vue?vue&type=template&id=60de3d5e"
import script from "./IlamBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./IlamBilgileriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports